import {view} from '@sail/ui';
import {SelectionCard} from 'src/v2/components/common/SelectionCard';
import {Badge} from 'src/v2/components/common/Badge';
import {WalletIcon} from 'src/v2/components/wallet/WalletIcon';
import {getWalletOptionKey} from 'src/v2/components/walletSelect/getWalletOptionKey';
import type {PaymentOption} from 'src/v2/state/types';
import {message, useIntl} from '@sail/intl';

interface Props {
  walletOptions: PaymentOption[];
  onWalletPress: (walletOption: PaymentOption) => void;
}

const messages = {
  installed: message({
    id: 'crypto.payins.v2.wallet_select.installed',
    description: 'A badge to signal that the wallet is installed',
    defaultMessage: 'Installed',
  }),
};

export const WalletSelectListResults = ({
  walletOptions,
  onWalletPress,
}: Props) => {
  const intl = useIntl();

  return (
    <view.div css={{stack: 'y', gapY: 'small'}} role="listbox">
      {walletOptions.map((walletOption) => {
        const isInstalled =
          'isInstalledOnBrowser' in walletOption &&
          walletOption.isInstalledOnBrowser;

        return (
          <SelectionCard
            key={getWalletOptionKey(walletOption)}
            icon={
              <WalletIcon
                walletOption={walletOption}
                width="32px"
                height="32px"
                borderRadius="medium"
              />
            }
            label={walletOption.name}
            accessory={
              isInstalled ? (
                <Badge>{intl.formatMessage(messages.installed)}</Badge>
              ) : undefined
            }
            onSelect={() => onWalletPress(walletOption)}
          />
        );
      })}
    </view.div>
  );
};
